import React, { useEffect, useState } from "react";
import "./confitmVerificationDetail.style.scss";
import { Button, Card, Input, Modal } from "antd";
import { get, post, responseValidator } from "../../../api";
import { toast } from "react-toastify";
import Loading from "../../../loading/loading.index";
import Lightbox from "react-awesome-lightbox";
import "react-awesome-lightbox/build/style.css";

export default function ConfirmVerificationDetail() {
    const [id, setId] = useState(null);
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [imageShowMedia, setImageShowMedia] = useState(false);
    const [imageShowSelfi, setImageShowSelfi] = useState(false);
    const [imageShowNationalCard, setImageShowNationalCard] = useState(false);

    const [rejectText, setRejectText] = useState(null);
    const [isConfirm, setIsConfirm] = useState(false);
    const [isReject, setIsReject] = useState(false);
    const [confirmLoading, setConfirmLoading] = useState(false);
    const [rejectLoading, setRejectLoading] = useState(false);

    useEffect(() => {
        setId(window.location.pathname.split("/")[4]);
        get("/AuthSurvey/" + window.location.pathname.split("/")[4]).then(
            res => {
                setLoading(false);
                if (res) {
                    if (responseValidator(res.status)) setData(res.data.data);
                    else if (res.data.message) toast.error(res.data.message);
                }
            }
        );
    }, []);

    function confirmHandler() {
        setConfirmLoading(true);
        post("/AuthSurvey/Approve", { id }).then(res => {
            setConfirmLoading(false);
            if (responseValidator(res.status)) {
                toast.success(res.data.message);
                setIsConfirm(false);
                setTimeout(
                    () =>
                        window.location.replace(
                            "/adminpanel/confirmverification"
                        ),
                    2000
                );
            } else {
                toast.error(res.data.message);
                setIsConfirm(false);
            }
        });
    }

    function rejectHandler() {
        setRejectLoading(true);
        post("/AuthSurvey/Reject", { id, description: rejectText }).then(
            res => {
                setRejectLoading(false);
                if (responseValidator(res.status)) {
                    toast.success(res.data.message);
                    rejectModalCancelHandler();
                    setTimeout(
                        () =>
                            window.location.replace(
                                "/adminpanel/confirmverification"
                            ),
                        2000
                    );
                } else {
                    toast.error(res.data.message);
                    rejectModalCancelHandler();
                }
            }
        );
    }

    function rejectModalCancelHandler() {
        setIsReject(false);
        setRejectText(null);
    }

    return (
        <div className="temx-confirm-verification-detail">
            {loading || !data ? (
                <Loading />
            ) : (
                <Card title="تایید صلاحیت">
                    <Modal
                        closable={false}
                        className="verification-my-modal"
                        footer={[
                            <Button
                                key="submit"
                                type="primary"
                                loading={confirmLoading}
                                onClick={confirmHandler}
                            >
                                بله
                            </Button>,
                            <Button
                                key="back"
                                onClick={() => setIsConfirm(false)}
                            >
                                خیر
                            </Button>
                        ]}
                        onCancel={() => setIsConfirm(false)}
                        visible={isConfirm}
                    >
                        <p>آیا از تایید کردن این مدرک اطمینان دارید ؟</p>
                    </Modal>
                    <Modal
                        closable={false}
                        className="verification-my-modal"
                        footer={[
                            <Button
                                disabled={!rejectText}
                                key="submit"
                                type="primary"
                                loading={rejectLoading}
                                onClick={rejectHandler}
                            >
                                بله
                            </Button>,
                            <Button
                                key="back"
                                onClick={rejectModalCancelHandler}
                            >
                                خیر
                            </Button>
                        ]}
                        onCancel={rejectModalCancelHandler}
                        visible={isReject}
                    >
                        <p>آیا از رد کردن این مدرک اطمینان دارید ؟</p>
                        <Input
                            value={rejectText}
                            onChange={e => setRejectText(e.target.value)}
                            placeholder="علت رد کردن"
                        />
                    </Modal>
                    <div className="detail">
                        <div className="items">
                            <label>نام کاربر : </label>
                            <p> {data.userFullname}</p>
                        </div>

                        <div className="items">
                            <label>تاریخ تولد : </label>
                            <p>
                                {" "}
                                {new Date(
                                    data.userBirthDate
                                ).toLocaleDateString("fa-IR")}
                            </p>
                        </div>

                        <div className="items">
                            <label>نوع مدرک : </label>
                            <p>
                                {" "}
                                {data.type.title === "MelliCard"
                                    ? "کارت ملی"
                                    : data.type.title === "SelfiPhoto"
                                    ? "عکس سلفی"
                                    : data.type.title === "MeliCardSelfi"
                                    ? "مدارک احراز هویت کامل"
                                    : "ویدیو سلفی"}
                            </p>
                        </div>

                        <div className="items">
                            <label>تاریخ ارسال : </label>
                            <p>
                                {" "}
                                {new Date(data.creationDate).toLocaleDateString(
                                    "fa-IR"
                                )}
                            </p>
                        </div>

                        <div className="items">
                            <label>وضعیت : </label>
                            {data.state.id === 0 ? (
                                <div className="pending-status">
                                    <p>{data.state.title}</p>
                                </div>
                            ) : data.state.id === 1 ? (
                                <div className="complete-status">
                                    <p>
                                        {data.state.title} توسط {data.modifier}{" "}
                                        در تاریخ{" "}
                                        {new Date(
                                            data.adminSurveyDateTime
                                        ).toLocaleDateString("fa-IR")}
                                    </p>
                                </div>
                            ) : (
                                <div className="error-status">
                                    <p>
                                        {data.state.title} توسط {data.modifier}{" "}
                                        در تاریخ{" "}
                                        {new Date(
                                            data.adminSurveyDateTime
                                        ).toLocaleDateString("fa-IR")}
                                    </p>
                                </div>
                            )}
                        </div>

                        {data.adminSurveyDateTime && (
                            <div className="items">
                                <label>تاریخ اخرین بررسی : </label>
                                <p>
                                    {" "}
                                    {new Date(
                                        data.adminSurveyDateTime
                                    ).toLocaleDateString("fa-IR")}
                                </p>
                            </div>
                        )}

                        {data.adminMessage && (
                            <div className="items">
                                <label>پیام مدیر : </label>
                                <p> {data.adminMessage}</p>
                            </div>
                        )}
                        <span className="my-spacer" />
                        <div className="my-btn">
                            <Button
                                disabled={data.state.id !== 0}
                                onClick={() => setIsConfirm(true)}
                                type={"primary"}
                            >
                                تایید کردن
                            </Button>
                            <Button
                                disabled={data.state.id !== 0}
                                onClick={() => setIsReject(true)}
                                type={"danger"}
                            >
                                رد کردن
                            </Button>
                        </div>
                    </div>
                    <span className="my-spacer" />
                    <div className="picture-container">
                        {data.media && (
                            <div className="picture">
                                {data.media.contentType.includes("image") && (
                                    <img
                                        style={{
                                            cursor: "pointer",
                                            padding: "25px",
                                            width: "300px"
                                        }}
                                        onClick={() => setImageShowMedia(true)}
                                        alt="verification-picture"
                                        src={
                                            `data:${data.media.contentType};base64,` +
                                            data.media.fileByteContent
                                        }
                                    />
                                )}
                                {data.media.contentType.includes("video") && (
                                    <video
                                        style={{
                                            cursor: "pointer",
                                            padding: "25px",
                                            width: "300px"
                                        }}
                                        controls={true}
                                        src={
                                            `data:${data.media.contentType};base64,` +
                                            data.media.fileByteContent
                                        }
                                    />
                                )}
                            </div>
                        )}
                        {data.selfiPhotoMedia && (
                            <div className="picture">
                                <p>تصویر سلفی</p>
                                <img
                                    style={{
                                        cursor: "pointer",
                                        padding: "25px",
                                        width: "300px"
                                    }}
                                    onClick={() => setImageShowSelfi(true)}
                                    alt="verification-picture"
                                    src={
                                        `data:${data.selfiPhotoMedia.contentType};base64,` +
                                        data.selfiPhotoMedia.fileByteContent
                                    }
                                />
                            </div>
                        )}
                        {data.nationalCardMedia && (
                            <div className="picture">
                                <p>تصویر کارت ملی</p>
                                <img
                                    style={{
                                        cursor: "pointer",
                                        padding: "25px",
                                        width: "300px"
                                    }}
                                    onClick={() =>
                                        setImageShowNationalCard(true)
                                    }
                                    alt="verification-picture"
                                    src={
                                        `data:${data.nationalCardMedia.contentType};base64,` +
                                        data.nationalCardMedia.fileByteContent
                                    }
                                />
                            </div>
                        )}
                    </div>
                    {imageShowMedia && (
                        <Lightbox
                            onClose={() => setImageShowMedia(false)}
                            image={
                                "data:image/png;base64," +
                                data.media.fileByteContent
                            }
                            title={
                                data.type.title === "MelliCard"
                                    ? "کارت ملی"
                                    : data.type.title === "SelfiPhoto"
                                    ? "عکس سلفی"
                                    : data.type.title === "MeliCardSelfi"
                                    ? "مدارک احراز هویت کامل"
                                    : "ویدیو سلفی"
                            }
                        />
                    )}

                    {imageShowNationalCard && (
                        <Lightbox
                            onClose={() => setImageShowNationalCard(false)}
                            image={
                                "data:image/png;base64," +
                                data.nationalCardMedia.fileByteContent
                            }
                            title={
                                data.type.title === "MelliCard"
                                    ? "کارت ملی"
                                    : data.type.title === "SelfiPhoto"
                                    ? "عکس سلفی"
                                    : data.type.title === "MeliCardSelfi"
                                    ? "مدارک احراز هویت کامل"
                                    : "ویدیو سلفی"
                            }
                        />
                    )}
                    {imageShowSelfi && (
                        <Lightbox
                            onClose={() => setImageShowSelfi(false)}
                            image={
                                "data:image/png;base64," +
                                data.selfiPhotoMedia.fileByteContent
                            }
                            title={
                                data.type.title === "MelliCard"
                                    ? "کارت ملی"
                                    : data.type.title === "SelfiPhoto"
                                    ? "عکس سلفی"
                                    : data.type.title === "MeliCardSelfi"
                                    ? "مدارک احراز هویت کامل"
                                    : "ویدیو سلفی"
                            }
                        />
                    )}
                </Card>
            )}
        </div>
    );
}
